import { lazy } from "@bridgesplit/ui";

const StrategyLoansDetail = lazy(() => import("./StrategyLoansDetail"));

export { StrategyLoansDetail };

export * from "./dialog";
export * from "./cards";
